import { createSelector } from '@reduxjs/toolkit';
import selectRawWorkflows from './selectRawWorkflows';

export default (workflowId) =>
  createSelector(selectRawWorkflows, (workflows) => workflows?.find(({ id }) => id === workflowId));
